import type { NodeDefinition } from '../../../types/node-definition';

const definition: NodeDefinition = {
  type: 'access-crm',
  name: 'Access CRM',
  category: 'access-integrations',
  description: 'Access CRM integration',
  icon: 'UserCircle',
  color: 'orange',
  version: '1.0.0',
  comingSoon: true,
  inputs: [
    {
      name: 'default',
      type: 'main',
      displayName: 'Input',
      required: true,
    },
  ],
  outputs: [
    {
      name: 'default',
      type: 'main',
      displayName: 'Output',
    },
  ],
};

export default definition;
